import { render, staticRenderFns } from "./LecturersGrid.vue?vue&type=template&id=5883c0ce&"
import script from "./LecturersGrid.vue?vue&type=script&lang=js&"
export * from "./LecturersGrid.vue?vue&type=script&lang=js&"
import style0 from "./LecturersGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports